export const zakresIleMiesiecyMobile = 12;

export const formatDatyBackend = 'yyyy-MM-dd';
export const dateDisplayFormatMobile = 'dd MMMM yyyy';
export const dateDisplayFormat = 'dd.MM.yyyy';
export const dateDisplayInfoMobile = 'dd.MM';
export const dateTerminyKalendarzAPI = 'y-MM-dd';
export const dateTerminyKalendarz = ' - dd.MM.y';

export const dniPL = [
  'PN',
  'WT',
  'ŚR',
  'CZ',
  'PT',
  'SB',
  'ND',
];
